import React, { useRef, useState } from "react";

const ImageDropBox = ({
  value,
  onChange,
  className = "",
  minHeight = 120,
  label = "Drag & drop an image here, or click to select",
  previewClass = "max-h-32 rounded border mb-2",
}) => {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    else if (e.type === "dragleave") setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleFile = (file) => {
    if (!file) {
      onChange(null);
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div
      className={`border-2 border-dashed rounded-lg p-6 flex flex-col items-center justify-center transition-colors cursor-pointer ${dragActive ? 'border-primary bg-primary/10' : 'border-primary/40 bg-base-100'} ${className}`}
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      onClick={() => fileInputRef.current && fileInputRef.current.click()}
      style={{ minHeight }}
    >
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={e => handleFile(e.target.files[0])}
      />
      {!value ? (
        <span className="text-primary/70 text-center">{label}</span>
      ) : (
        <div className="flex flex-col items-center w-full">
          <img src={value} alt="Preview" className={previewClass} />
          <button
            type="button"
            className="btn btn-xs btn-error text-white"
            onClick={e => {
              e.stopPropagation();
              onChange(null);
              if (fileInputRef.current) fileInputRef.current.value = "";
            }}
          >
            Remove Image
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageDropBox;